import React, { useState } from 'react';
import { Container, Typography, Box, Paper, TextField, Button, CircularProgress, Alert } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { HowToReg as HowToRegIcon } from '@mui/icons-material';
import userService from '../services/userService'; // Importer le service

const RegisterPage = () => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
        const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const validateForm = () => {
        const newErrors = {};
        if (!username) newErrors.username = "Le nom d'utilisateur est requis";
        if (!email) {
            newErrors.email = "L'email est requis";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = "Format d'email invalide";
        }
        if (!password) newErrors.password = 'Le mot de passe est requis';
        if (password !== password2) newErrors.password2 = 'Les mots de passe ne correspondent pas';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setSuccessMessage('');
        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return;
        }
        setLoading(true);
        try {
            const userData = { username, email, password: password, password_confirm: password2 };
            await userService.registerUser(userData);
            setSuccessMessage("Inscription réussie ! Un email de confirmation a été envoyé. Vous pouvez maintenant vous connecter.");
            setTimeout(() => {
                navigate('/login?registration=success');
            }, 3000);
        } catch (error) {
            const formattedErrors = {};
            const apiErrors = error.response ? error.response.data : (typeof error === 'object' ? error : null);

            if (apiErrors && typeof apiErrors === 'object') {
                // Gérer les erreurs spécifiques aux champs et les erreurs non liées à un champ
                for (const [field, messages] of Object.entries(apiErrors)) {
                    const key = field === 'non_field_errors' ? 'general' : field;
                    formattedErrors[key] = Array.isArray(messages) ? messages.join(' ') : messages;
                }
            } else {
                // Gérer les erreurs réseau ou les réponses non-JSON
                formattedErrors.general = "Une erreur de communication est survenue. Veuillez réessayer.";
            }

            // S'assurer qu'il y a au moins un message d'erreur à afficher
            if (Object.keys(formattedErrors).length === 0) {
                formattedErrors.general = "Une erreur inattendue est survenue.";
            }

            setErrors(formattedErrors);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container component="main" maxWidth="sm">
            <Paper elevation={6} sx={{ marginTop: 8, padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: 3 }}>
                <Typography component="h1" variant="h4" gutterBottom>
                    Créer un compte
                </Typography>

                                {errors.general && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{errors.general}</Alert>}
                {successMessage && <Alert severity="success" sx={{ width: '100%', mb: 2 }}>{successMessage}</Alert>}

                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Nom d'utilisateur"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        error={!!errors.username}
                        helperText={errors.username}
                        disabled={loading}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Adresse Email"
                        name="email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        error={!!errors.email}
                        helperText={errors.email}
                        disabled={loading}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Mot de passe"
                        type="password"
                        id="password"
                        autoComplete="new-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        error={!!errors.password}
                        helperText={errors.password}
                        disabled={loading}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password2"
                        label="Confirmer le mot de passe"
                        type="password"
                        id="password2"
                        autoComplete="new-password"
                        value={password2}
                        onChange={(e) => setPassword2(e.target.value)}
                        error={!!errors.password2}
                        helperText={errors.password2}
                        disabled={loading}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        size="large"
                        sx={{ mt: 3, mb: 2, height: 56, borderRadius: 3 }}
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <HowToRegIcon />}
                    >
                        {loading ? "Création en cours..." : "S'inscrire"}
                    </Button>
                    <Box textAlign="center">
                        <Typography variant="body2">
                            Déjà un compte ?{' '}
                            <RouterLink to="/login" style={{ textDecoration: 'none', fontWeight: 'bold', color: 'inherit' }}>
                                Connectez-vous
                            </RouterLink>
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default RegisterPage;
